export default function NiveauxHierarchiquesConfiguration($translatePartialLoaderProvider) {
    $translatePartialLoaderProvider.addPart('niveauxhierarchiques');
}

NiveauxHierarchiquesConfiguration.$inject = ['$translatePartialLoaderProvider'];
